import Title from './Title';

const Ids = ({ids}) => {

      if(ids.length === 0 || ids.data) return 

      return (
            <div className="main_ids__content">
                  <div className="container">
                        <Title title={'Ids'} desc={'Available And Prices'} />
                        <div className="main_table">
                              <table>
                                    <thead>
                                          <tr>
                                                <th>Id</th>
                                                <th>Digits</th>
                                                <th>Disponibility</th>
                                                <th>Price</th>
                                          </tr>
                                    </thead>
                                    <tbody>
                                          {
                                                ids.map((item) => (
                                                      <tr key={item.id_number}>
                                                            <td><strong>{item.id_number}</strong></td>
                                                            <td>{item.id_digits}</td>
                                                            <td><span>{item.status}</span></td>
                                                            <td><strong>{item.price}</strong></td>
                                                      </tr>
                                                ))
                                          }
                                    </tbody>
                              </table>
                        </div>
                  </div>
            </div>
      )
}

export default Ids;